import { createSlice } from "@reduxjs/toolkit";
import { LoadState } from "../../../constants/enums";
import { initialLeadApplicationsState } from "./leadApplications.types";
import { fetchLeadApplicationsList } from "./leadApplicationsThunk";

const leadApplicationsSlice = createSlice({
  name: "leadApplications",
  initialState: initialLeadApplicationsState,
  reducers: {
    clearLeadApplicationsState: (state) => {
      state.list = [];
      state.totalRecords = 0;
      state.loading = LoadState.NotLoaded;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLeadApplicationsList.pending, (state) => {
        state.loading = LoadState.InProgress;
        state.list = [];
        state.totalRecords = 0;
      })
      .addCase(fetchLeadApplicationsList.fulfilled, (state, action) => {
        state.loading = LoadState.Loaded;
        state.list = action.payload.data;
        state.totalRecords = action.payload.totalRecords;
      })
      .addCase(fetchLeadApplicationsList.rejected, (state) => {
        state.loading = LoadState.Failed;
        state.list = [];
        state.totalRecords = 0;
      });
  },
});

export const { clearLeadApplicationsState } = leadApplicationsSlice.actions;
export const leadApplicationsReducer = leadApplicationsSlice.reducer;
